// A direct click on one of these performs its own behavior, so a facility that
// delegates a click elsewhere leaves it alone. - Aaron, Sun Jul 26 2026
export const interactiveSelector = "a, button, input, select, textarea, label, summary, [role='button'], [contenteditable='true']"
